import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Row, Col } from 'react-bootstrap';
import OverlayLoader from '../../components/overlayLoader';
import { createServiceCategory, getServiceCategoryById, updateServiceCategory } from '../../services/services';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { onMutateSuccess, onQuerySuccess } from '../../utils/queryResponse';
import FormInput from '../../components/forms/formInput';
import { useEffect } from 'react';
import { trimProps } from '../../utils/helper';
import SbrDrawer from '../../components/sbr/SbrDrawer';

const LayersIcon = () => (
    <svg className="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 2 7 12 12 22 7 12 2" /><polyline points="2 17 12 22 22 17" /><polyline points="2 12 12 17 22 12" /></svg>
);

const initServiceCategory = { name: '' }

const SetServiceCategoryModal = ({
    display,
    toggle,
    serviceCategoryId,
}) => {

    const { t } = useTranslation();
    const [serviceCategory, setServiceCategory] = useState(initServiceCategory)

    const onShow = () => {
        !serviceCategoryId && setServiceCategory(initServiceCategory)
    }

    const onHide = () => {
        toggle(false)
    }

    const queryClient = useQueryClient()

    const { mutate, isLoading } = useMutation(serviceCategoryId ? updateServiceCategory : createServiceCategory, {
        onSuccess: onMutateSuccess(() => {
            queryClient.invalidateQueries(['service-categories'])
            onHide()
        })
    })

    const { data, isFetching } = useQuery(['service-categories','details', serviceCategoryId], () => serviceCategoryId && getServiceCategoryById(serviceCategoryId), {
        staleTime: 1000 * 60 * 2,
    })

    useEffect(() => {
        onQuerySuccess(data, (result) => {
            const _serviceCategory = trimProps(result, initServiceCategory, ['id'])
            setServiceCategory(_serviceCategory)
        })
    }, [data])

    const handleSubmit = (e) => {
        e.preventDefault()
        e.stopPropagation()
        mutate(serviceCategory)
    }

    const handleChange = (objValue) => {
        const newServiceCategory = { ...serviceCategory, ...objValue }
        setServiceCategory(newServiceCategory)
    }

    return (
        <>
            <SbrDrawer
                show={display}
                onHide={onHide}
                onShow={onShow}
                secondary
                backdrop={isLoading ? 'static' : true}
                title={serviceCategoryId ? t('settingsPage.editServiceCategoryTitle') : t('settingsPage.addServiceCategoryTitle')}
                subtitle={serviceCategoryId ? t('settingsPage.editServiceCategorySubtitle') : t('settingsPage.addServiceCategorySubtitle')}
                icon={<LayersIcon />}
                footer={
                    <>
                        <button type="button" className="btn-sbr btn-ghost-sbr btn-sm-sbr" onClick={onHide} disabled={isLoading}>{t('common.cancel')}</button>
                        <button type='submit' form="set-service-category" className="btn-sbr btn-primary-sbr btn-sm-sbr" disabled={isLoading}>
                            {isLoading ? t('settingsPage.submitting') : (serviceCategoryId ? t('settingsPage.saveCategory') : t('settingsPage.addCategoryBtn'))}
                        </button>
                    </>
                }
            >
                <Form id='set-service-category' onSubmit={handleSubmit} style={{ position: 'relative' }}>
                    <Row className="mb-3">
                        <Col>
                            <FormInput className="form-control mb-2" label={t('settingsPage.categoryName')} value={serviceCategory.name ?? ''}
                                onChange={(e) => handleChange({ name: e.target.value })} required
                            />
                        </Col>
                    </Row>

                    {isFetching &&
                        <OverlayLoader />
                    }

                </Form>
            </SbrDrawer>

        </>
    );
};

export default SetServiceCategoryModal;
